import React from "react";
import classNames from "classnames/bind";
import styles from "./CartFooter.module.scss";
import useCheckoutProductStore from "../../stores/CheckoutProduct/useCheckoutProductStore";
import { useNavigate } from "react-router-dom"; // ✅ Dùng useNavigate
import { useCartSidebarStore } from "../../stores/Cart/cartSidebarStore";

const cx = classNames.bind(styles);

const CartFooter = ({
  disabled = false,
  buttonText = "CHECKOUT",
  className,
}) => {
  const { toTalItems } = useCheckoutProductStore();
  const { close } = useCartSidebarStore();
  const navigate = useNavigate(); // ✅ Khởi tạo navigate

  const handleCheckoutClick = (e) => {
    // e.preventDefault();

    if (toTalItems <= 0 || disabled) return;

    close();
    navigate("/checkout"); // ✅ Điều hướng đúng cách
  };

  return (
    <div className={cx("cart-footer", className)}>
      <button
        className={cx("checkout-btn")}
        disabled={disabled}
        onClick={handleCheckoutClick}
      >
        {buttonText} ({toTalItems})
      </button>
    </div>
  );
};

export default CartFooter;
